import React, {useEffect, useRef, useState} from "react";
import apiClient from "../axios/axiosInterceptor";
import Dialog from "@mui/material/Dialog";
import {Box, FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import DialogFormActions from "../shared/DialogFormActions";

function UserCreate({ loggedInUser, user, onClose, onSubmit }) {
    const [username, setUsername] = useState(user ? user.username : '');
    const [firstname, setFirstname] = useState(user ? user.firstname : '');
    const [lastname, setLastname] = useState(user ? user.lastname : '');
    const [roleId, setRoleId] = useState(user ? user.roleId : '');
    const [emailAddress, setEmailAddress] = useState(user ? user.emailAddress : '');

    const [roles, setRoles] = useState([]);

    const dialogRef = useRef(null);

    useEffect(() => {
        const fetchRoles = async () => {
            const url = `/tenants/${loggedInUser.TenantId}/roles`;
            const response = await apiClient.get(url);
            setRoles(response.data.list);
        };

        fetchRoles();
    }, [loggedInUser.TenantId]);

    const handleSubmit = e => {
        e.preventDefault();
        onSubmit({ username, firstname, lastname, roleId, emailAddress });
    };

    const handleClose = (event: {}, reason: "backdropClick" | "escapeKeyDown") => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
        }
        onClose();
    };

    return (
        <React.Fragment>
            <Dialog
                open={true}
                onClose={handleClose}
                className="core-dialog"
            >
                <Box ref={dialogRef}>
                    <DialogTitle sx={{fontWeight: 'bold'}}>{user ? 'Edit' : 'Create'} User</DialogTitle>
                    <form
                        onSubmit={handleSubmit}
                        style={{display: 'contents'}}
                        className="core-form"
                    >
                        <DialogContent className="core-dialog-content">
                            <div className="core-form-row-item">
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="username"
                                    label="Username"
                                    name="username"
                                    variant="standard"
                                    value={username}
                                    fullWidth
                                    onChange={e => setUsername(e.target.value)}
                                    InputProps={{ readOnly: user !== null }}
                                />
                            </div>

                            <div className="core-form-row-item">
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="firstname"
                                    label="Firstname"
                                    name="firstname"
                                    variant="standard"
                                    value={firstname}
                                    fullWidth
                                    onChange={e => setFirstname(e.target.value)}
                                />
                            </div>

                            <div className="core-form-row-item">
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="lastname"
                                    label="Lastname"
                                    name="lastname"
                                    variant="standard"
                                    value={lastname}
                                    fullWidth
                                    onChange={e => setLastname(e.target.value)}
                                />
                            </div>

                            <div className="core-form-row-item">
                                <FormControl fullWidth>
                                    <InputLabel id="roleLabel">Select a Role</InputLabel>
                                    <Select
                                        labelId="roleLabel"
                                        id="role"
                                        value={roleId}
                                        label="Role"
                                        onChange={e => setRoleId(parseInt(e.target.value))}
                                        variant={'outlined'}
                                    >
                                        {roles.map(role => (
                                            <MenuItem value={role.id}>{role.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                            <div className="core-form-row-item">
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="emailAddress"
                                    type={"email"}
                                    label="Email"
                                    name="emailAddress"
                                    variant="standard"
                                    value={emailAddress}
                                    fullWidth
                                    onChange={e => setEmailAddress(e.target.value)}
                                />
                            </div>
                        </DialogContent>
                        <DialogFormActions dialogRef={dialogRef} onClose={onClose}></DialogFormActions>
                    </form>
                </Box>
            </Dialog>
        </React.Fragment>
    );
}

export default UserCreate;
